<template>
  <div class="speed">
    <h3>Velocidade (m/min)</h3>

    <select v-model.number="localPreset">
      <option :value="300">Treino (300)</option>
      <option :value="325">Indoor (325)</option>
      <option :value="350">Padrão (350)</option>
      <option :value="375">Grande pista (375)</option>
      <option :value="-1">Personalizada…</option>
    </select>

    <div v-if="localPreset === -1" class="row">
      <label>Personalizada</label>
      <input type="number" step="5" v-model.number="localCustom" />
    </div>

    <div class="hint">Comprimento: {{ fmtM(courseMeters) }}</div>
    <div class="hint">TA: {{ fmtSec(taSec) }} | TL: {{ fmtSec(tlSec) }}</div>
    <div class="hint">Tempo Ótimo (Tabela IV): {{ fmtSec(optSec) }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  preset:        { type: Number, required: true },
  custom:        { type: Number, required: true },
  courseMeters:  { type: Number, default: 0 },
  taSec:         { type: Number, default: 0 },
  tlSec:         { type: Number, default: 0 },
  optSec:        { type: Number, default: 0 },
})
const emit = defineEmits(['update:preset', 'update:custom'])

const localPreset = computed({
  get: () => props.preset,
  set: v => emit('update:preset', Number(v))
})
const localCustom = computed({
  get: () => props.custom,
  set: v => emit('update:custom', Number(v))
})

function toBR(n, digs = 2) { return (n==null||Number.isNaN(+n)) ? '—' : (+n).toFixed(digs).replace('.', ',') }
function fmtM(n, digs = 2) { return n==null ? '—' : `${toBR(n, digs)} m` }
function fmtSec(s) {
  const v = Math.max(0, Number(s) || 0)
  const m = Math.floor(v / 60)
  const sec = Math.round(v - m * 60)
  return `${m}:${String(sec).padStart(2, '0')}s`
}
</script>

<style scoped>
.speed h3 { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
.speed select, .speed input[type="number"] {
  width: 100%; padding: 6px 8px; border-radius: 4px;
  border: 1px solid #2b3350; background: #e9edf7; color: #111;
}
.speed .row { margin-top: 6px; display: flex; align-items: center; gap: 8px; }
.speed .row label { font-size: 12px; color: #c7d2fe; width: 120px; }
.speed .hint { font-size: 12px; color: #cbd5e1; margin-top: 4px; }
</style>
